import { GridItem, Box } from '@flos/react-ui';
import type { LobStatusFieldsValidation } from '../steps/DatesAndCancellationStep';
import { EdiCaseStatusMap } from '../steps/DatesAndCancellationStep';
import { EDICancellationChooseStatus } from './EDICancellationChooseStatus';
import EDICancellationNo from './EDICancellationNo';
import EDICancellationYes from './EDICancellationYes';
import StringParagraph from './StringParagraph';
import StringTitle from './StringTitle';
import { useRecoilValue } from 'recoil';
import { allCoverablesAtom } from '../../../recoil/atoms/allCoverablesAtom';
import { allCoverablesToCoverableDTOArray } from '../../../utils/coverablesUtil';
import {
    externalCaseToCoverable,
    isCarWithTilgangReceived
} from '../../../utils/externalCasesUtil';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto/';
import { selectableInsuranceCompaniesSelector } from '../../../recoil/selectors/selectableInsuranceCompaniesSelector';
import type { OptionProps } from '@flos/react-ui/build/core/forms/select/select-input';
import { EDICancellationExternalCaseCarTilgang } from './EDICancellationExternalCaseCarTilgang';

export const EDICancellationExternalCase = ({
    externalCase,
    lobStatusFieldValidation
}: {
    externalCase: ExternaleCaseDTO;
    lobStatusFieldValidation: LobStatusFieldsValidation;
}): React.JSX.Element => {
    const allCoverablesDTO = useRecoilValue(allCoverablesAtom);
    const allCoverables = allCoverablesToCoverableDTOArray(allCoverablesDTO);
    const coverable = externalCaseToCoverable(externalCase, allCoverables);
    const { status, caseId } = externalCase;
    let companiesSelection: OptionProps[] = useRecoilValue(selectableInsuranceCompaniesSelector);

    if (
        externalCase.otherCompany &&
        companiesSelection.findIndex(
            (company) => company.value === externalCase.otherCompany?.code
        ) === -1
    ) {
        companiesSelection = [
            ...companiesSelection,
            {
                label: externalCase.otherCompany.name ?? '',
                value: externalCase.otherCompany.code ?? ''
            }
        ];
    }

    if (!caseId || !coverable) return <></>;

    return (
        <GridItem span={12} key={caseId}>
            {isCarWithTilgangReceived(coverable) ? (
                <EDICancellationExternalCaseCarTilgang car={coverable} />
            ) : (
                <Box className="cancellationCaseBox">
                    <StringTitle>{String(coverable.flavourName)}</StringTitle>
                    <StringParagraph className={'h6 u-color-secondary-4-medium'}>
                        {coverable.name}
                    </StringParagraph>
                    <EDICancellationChooseStatus
                        externalCase={externalCase}
                        flavourName={coverable.flavourName ?? ''}
                        coverableName={coverable.name}
                        lobStatusFieldValidation={lobStatusFieldValidation}
                    />
                    {(status === EdiCaseStatusMap.ReadyForSend ||
                        status === EdiCaseStatusMap.PendingCompletion) && (
                        <EDICancellationYes
                            externalCase={externalCase}
                            coverable={coverable}
                            companiesSelection={companiesSelection}
                            lobStatusFieldValidation={lobStatusFieldValidation}
                        />
                    )}
                    {status === EdiCaseStatusMap.NotRequired && (
                        <EDICancellationNo
                            externalCase={externalCase}
                            coverable={coverable}
                            lobStatusFieldValidation={lobStatusFieldValidation}
                        />
                    )}
                </Box>
            )}
        </GridItem>
    );
};
